import validate from "/work/modules/node_modules/nuxt/dist/pages/runtime/validate.js";
import search_45redirect_45global from "/storage/data/jenkins/workspace/WEBPLATFORM/FRONTEND/CANYON/CANYON_Deploy_Prod@2/middleware/search-redirect.global.ts";
import frontkit_45trailing_45slash from "/work/modules/node_modules/@webplatform/frontkit/dist/runtime/middleware/trailingSlashRedirect.js";
import frontkit_45persist_45utm from "/work/modules/node_modules/@webplatform/frontkit/dist/runtime/middleware/persistUtmQueryParams.js";
import manifest_45route_45rule from "/work/modules/node_modules/nuxt/dist/app/middleware/route-rules.js";
export const globalMiddleware = [
  validate,
  search_45redirect_45global,
  frontkit_45trailing_45slash,
  frontkit_45persist_45utm,
  manifest_45route_45rule
]
export const namedMiddleware = {}